import { Box, Card, Divider, Grid, Typography } from "@material-ui/core"
import { CardInfoConfirmarEntregaProps } from "./card-info-confirmar-entrega-props";
import { isEmpty } from "lodash";
import { useStyles } from "./card-info-confirmar-entrega-styles";
import { formatarCPFCNPJ } from "../../../../utils/cpfcnpj-format";
import { toDateString } from "../../../../utils/to-date";
import { pegaHora } from "../../../../utils/pegar-data";
import { CardProdutosConfirmarEntrega } from "../card-produtos-confirmar-entrega/card-produtos-confirmar-entrega";
import { KdsStorageKeys, useKdsStorage } from "../../../../services/app";
import { ModuloModel } from "../../../../model/app/forms/master/modulo-model";
import { EnumModulo } from "../../../../model/enums/enum-modulo";
import { PedidoEnderecoModel } from "../../../../model/api/pedidos/pedido-model";
import { useMemo } from "react";

export const CardInfoConfirmarEntrega = ({ model }: CardInfoConfirmarEntregaProps) => {

    const classes = useStyles();
    const { getRegistro } = useKdsStorage();

    const tipoTrabalho = getRegistro(KdsStorageKeys.SelecaoModulo, false) as ModuloModel;

    const retornaEndereco = useMemo(() => {

        const { bairro, municipio, numero, complemento, logradouro, uf } = model.pedido?.enderecoEntrega ?? new PedidoEnderecoModel()

        if (isEmpty(model.pedido?.enderecoEntrega)) {
            return ''
        }

        return `${logradouro ?? ''}, ${numero ?? 0} - ${bairro ?? ''}${municipio ? `, ${municipio}` : ''}${uf ? ` - ${uf}` : ''}${complemento ? `, ${complemento}` : ''}`
    }, [model.pedido?.enderecoEntrega])

    return (
        <>
            <Card className={classes.container}>
                <Grid container spacing={2} style={{
                    overflowY: 'auto',
                }}>
                    <Grid item xs={12}>
                        <Grid container style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div>
                                <Typography
                                    variant="h6"
                                    color="textPrimary"
                                >
                                    <Box fontWeight={700}>
                                        {`Pedido N° ${model.codigoPedido}`}
                                    </Box>
                                </Typography>

                            </div>
                            <div>
                                <Typography
                                    variant="body2"
                                    color="primary"
                                >
                                    <Box fontWeight={500}>
                                        {toDateString(new Date(model.dataPedido))} - {pegaHora(model.dataPedido)}
                                    </Box>
                                </Typography>
                            </div>
                        </Grid>
                        <Divider variant="fullWidth" className={classes.divider} />
                    </Grid>
                    {tipoTrabalho.modulo === EnumModulo.EntregaLocal && (
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        Comanda
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        color="textPrimary"
                                    >
                                        <Box component="span" fontWeight={700}>
                                            {!isEmpty(model.codigoComanda) ? model.codigoComanda : '-'}
                                        </Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        Mesa
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        color="textPrimary"
                                    >
                                        <Box component="span" fontWeight={700}>
                                            {!isEmpty(model.codigoMesa) ? model.codigoMesa : '-'}
                                        </Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        Salão
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        color="textPrimary"
                                    >
                                        {!isEmpty(model.nomeSalao) ? model.nomeSalao : 'Sem Salão'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid xs={8}>
                                <Typography
                                    variant="body2"
                                    color='textSecondary'
                                >
                                    Cliente
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                >
                                    <Box fontWeight={600}>
                                        {!isEmpty(model.nomeCliente) ? model.nomeCliente : 'Sem Cliente'}
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid xs={4}>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    CPF/CNPJ
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                >
                                    {!isEmpty(model.documentoClinte) ? formatarCPFCNPJ(model.documentoClinte) : '-'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    {tipoTrabalho.modulo === EnumModulo.EntregaDelivery && (
                        <Grid item xs={12}>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                            >
                                Endereço
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textPrimary"
                            >
                                {retornaEndereco.length <= 5 ? 'Sem Endereço' : retornaEndereco}
                            </Typography>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <CardProdutosConfirmarEntrega
                            produtos={model.produtos}
                        />
                    </Grid>
                </Grid>
            </Card>
        </>
    )
}